<section class="global-loading">
	<img src="/assets/images/tcb-logo.png" alt="Loading spinner" />
	<p class="text-[18px] mt-5">
		<!-- Cargando... -->
		<span>C</span>
		<span>a</span>
		<span>r</span>
		<span>g</span>
		<span>a</span>
		<span>n</span>
		<span>d</span>
		<span>o</span>
		<span>.</span>
		<span>.</span>
		<span>.</span>
	</p>
</section>
